import { api } from '..';

export const deletePreset = async (id: number) => {
  const data = await api.delete(`/api/v1/general/user/preset/?pk=${id}`);
  return data;
};
